function GradientSVG() {
    const gradientTransform = `rotate(360)`;
    return (
        <svg style={{ height: 0, position: "absolute" }}>
            <defs>
                <linearGradient id='gradient-circ-progress' gradientTransform={gradientTransform}>
                    <stop offset="16.29%" stopColor="#d37536" />
                    <stop offset="85.56%" stopColor="#d37536" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default GradientSVG;
